<template>
    <li class="w-full h-full flex items-center">
        <div class="-ml-3.5 flex-none h-full w-28 sm:w-32 bg-center bg-no-repeat bg-contain"
            :style="{
                backgroundImage: groupImage,
            }"
        >
            <transition name="cz3__fade">
                <span
                    v-if="showCheckmark"
                    class="mt-0.5 ml-3 text-green font-black text-xl"
                >
                    &check;
                </span>
            </transition>
        </div>

        <div
            :class="{ 'text-red': hasErrors }"
            class="mr-1.5 flex-1 break-words text-left"
        >
            <p class="text-sm font-bold">
                {{ groupName }}
            </p>

            <base-error-message
                :category-name="itemData.name"
                class="mt-1"
            />
        </div>

        <current-selection
            :placement-data="itemData"
            class="w-20 text-right"
        />
    </li>
</template>

<script>
    import allStores from '../stores/all';

    import CurrentSelection from './CurrentSelection.vue';
    import BaseErrorMessage from './BaseErrorMessage.vue';

    import { autoWebp } from '../helpers/images';

    export default {
        mixins: [allStores],

        components: {
            CurrentSelection,
            BaseErrorMessage,
        },

        props: {
            itemData: {
                type: Object,
                required: true,
            },
        },

        computed: {
            groupName() {
                const editedName = this.itemData.name.replace(' Color', '');
                let translatedName = this.customizerStore.useTranslations(this.itemData.custom?.['fj-translation-code'], editedName);

                if (this.disableEdit) {
                    translatedName = translatedName.replace('Select ', '');
                }

                return translatedName;
            },

            /**
             * Grab the first accordion image from any placement in this group.
             */
            groupImage() {
                const placementWithImage = this.itemData?.placements?.find((placement) => placement.custom?.['fj-accordion-image']);

                if (placementWithImage) {
                    return `url(${autoWebp(placementWithImage.custom['fj-accordion-image'])})`;
                }

                // Is there a group image?
                if (this.itemData.custom?.['fj-accordion-image']) {
                    return `url(${autoWebp(this.itemData.custom['fj-accordion-image'])})`;
                }

                return '';
            },

            selectionWasMade() {
                return this.customizerStore.selectionsMade.includes(this.itemData.name);
            },

            inErrorState() {
                return this.customizerStore.inErrorState;
            },

            hasBackorderedError() {
                return this.customizerStore.hasBackorderedError;
            },

            hasBackorderedSize() {
                return this.customizerStore.hasBackorderedSize;
            },

            hasSizeErrors() {
                return (this.hasBackorderedError && this.itemData.name.includes('Size'));
            },

            hasErrors() {
                return (this.inErrorState && !this.selectionWasMade) || this.hasSizeErrors;
            },

            showCheckmark() {
                return this.selectionWasMade && !this.hasSizeErrors && !this.hasBackorderedSize;
            },

            disableEdit() {
                return this.customizerStore.disableEdit;
            },
        },
    };
</script>
